// removed by extract-text-webpack-plugin
module.exports = {"component-wrapper":"styles__component-wrapper___2Flqe","component-title":"styles__component-title___mNiWT","diagnostics-table":"styles__diagnostics-table___23OHA","table-header":"styles__table-header___qUHf3","diagnostic-data":"styles__diagnostic-data___ERjOO","diagnostic-value":"styles__diagnostic-value___2Am_n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportComponents/Tables/DiagnosticOutput/styles.scss
// module id = 7301
// module chunks = 0